import { useState, useEffect, Fragment } from 'react';
import { useNavigate } from 'react-router';
import forwardArrow from '../../../assets/icons/forward.svg';
import { playSong } from '../../common/actions/common.actions';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { selectLoginData } from "../login/login.actions";
import Modal from '../../common/components/modal';
import { IoIosArrowBack } from "react-icons/io";
import { useTranslation } from "react-i18next";
import transactionService from '../../../api/services/transactionService';
import Deposite from './deposite';
import Withdrawal from './withdrawal';

const Transactions = ({ setIsLoading }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [message, setMessage] = useState(t('processSuccessful'));
    const [accountList, setAccountList] = useState([]);
    const [activeTab, setActiveTab] = useState('deposite');
    const [balance,setBalance] = useState(0);

    const userDetails = JSON.parse(localStorage.getItem("userDetails"));

    useEffect(() => {
       fetchAccountList();
    }, [])

    const fetchAccountList = async () => {
        try {
            setIsLoading(true);
            const response = await transactionService.getPaymentAccountList(Number(userDetails.userId));
            const data = await response.json();

            if (data) {
                setAccountList(data.payload);
                setBalance(data.balance);
            }
        } catch (error) {
            console.error("API request error:", error);
        } finally {
            setIsLoading(false);
        }
    }

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const handleSongClick = async () => {
        dispatch(playSong());
      };

    const handleClick = () => {
        handleSongClick();
        navigate('/dashboard');
      };

    return (
        <div className="flex h-screen flex-col w-full items-center bg-white dark:bg-background bg-opacity-90 font-dangrek">
            <div className="w-full flex justify-between items-center text-center py-2 pr-5 border-b dark:shadow-sm bg-gradient-to-r from-slate-300 to-slate-100">
                <div className="flex items-center pr-2">
                    <button
                        className="top-3 left-3 w-10 h-10 mr-3
                      rounded-full drop-shadow-lg flex justify-center items-center text-waterDOne text-4xl"
                      onClick={handleClick}
                    >
                        {/* <img src={forwardArrow} alt="Back Arrow" /> */}
                        <IoIosArrowBack size={25} className="text-waterDOne" />
                    </button>
                    <h3 className="text-lg ml-3 text-center font-dangrek text-waterDOne">
                        {t("transaction")}
                    </h3>
                </div>
            </div>
            <div className="flex flex-col items-center justify-center">
                <div className="flex space-x-1 my-4">
                    <button className={`group py-2 px-3 rounded-l-lg border-2 border-waterFive transition-all duration-300 hover:bg-waterFive hover:text-white
                    ${activeTab === 'deposite'
                            ? 'bg-waterFive text-white'
                            : 'bg-white text-waterFive'
                        }`}
                        onClick={() => setActiveTab('deposite')}
                    >
                        <span
                            className={`group-hover:text-white text-sm transition-colors ${activeTab === 'deposite' ? 'text-white' : 'text-waterFive'
                                }`}
                        >
                             {t("deposite")}
                        </span>
                    </button>

                    <button className={`group py-2 px-3 rounded-r-lg border-2 border-waterFive transition-all duration-300 hover:bg-waterFive hover:text-white
                    ${activeTab === 'withdraw'
                            ? 'bg-waterFive text-white'
                            : 'bg-white text-waterFive'
                        }
                    `}
                        onClick={() => setActiveTab('withdraw')}
                    >
                        <span
                            className={`group-hover:text-white text-sm transition-colors ${activeTab === 'withdraw' ? 'text-white' : 'text-waterFive'
                                }`}
                        >
                             {t("withdraw")}
                        </span>
                    </button>
                </div>
                {
                    activeTab === "deposite" ?
                    <Deposite
                    accountList={accountList}
                    t={t}
                    userDetails={userDetails}
                    setIsLoading={setIsLoading}
                    setIsModalOpen={setIsModalOpen}
                    setMessage={setMessage}
                    handleSongClick={handleSongClick}
                    />
                    : <Withdrawal
                    accountList={accountList}
                    t={t}
                    userDetails={userDetails}
                    balance={balance}
                    fetchAccountList = {fetchAccountList}
                    setIsLoading={setIsLoading}
                    setIsModalOpen={setIsModalOpen}
                    setMessage={setMessage}
                    handleSongClick={handleSongClick}
                    />
                }
            </div>
            {isModalOpen && (
                <Modal title="Lucky 7" content={message} onClose={closeModal} />
            )}
        </div>
    );
};

export default Transactions;
